import React, { useState } from "react";
import { Link } from "gatsby";
import CinemaItemImage from "./CinemaItemImage";
import Share from "../../components/Share";
import "./index.css";

const CinemaItem = ({ node, allImages }) => {
  const [share, setShare] = useState(false);

  const item = node;
  const image = allImages.filter(
    (edge) => item.frontmatter.images.indexOf(edge.node.fluid.originalName) >= 0
  );

  image.sort((a, b) => {
    const bandA = a.node.fluid.originalName.toUpperCase();
    const bandB = b.node.fluid.originalName.toUpperCase();

    let comparison = 0;
    if (bandA > bandB) {
      comparison = 1;
    } else if (bandA < bandB) {
      comparison = -1;
    }
    return comparison;
  });

  return (
    <article key={item.frontmatter.slug} className="cinemaitem-main">
      <header className="cinemaitem-title">
        <h3>
          <Link style={{ boxShadow: `none` }} to={item.frontmatter.slug}>
            {item.frontmatter.title}
          </Link>
        </h3>
      </header>
      <section>
        <section style={{ height: `300px` }}>
          {image.map((img) => {
            return (
              <CinemaItemImage
                image={img}
                allImages={allImages}
                key={Math.random()}
              />
            );
          })}
        </section>

        <section
          className="cinemaitem-text"
          dangerouslySetInnerHTML={{ __html: item.html }}
        />
        {item.frontmatter.tags.map((tag) => {
          return (
            <Link
              className="cinemaitem-tag"
              to={`/`}
              key={tag}
            >{`#${tag}`}</Link>
          );
        })}
        <div className="cinemaitem-icons">
          <div
            href="#"
            onClick={() => {
              setTimeout(() => {
                setShare(false);
              }, 2000);
              setShare(true);

              var dummy = document.createElement("textarea");
              document.body.appendChild(dummy);
              dummy.value = `https://wordscutdeepest.xyz/${item.frontmatter.slug}`;
              dummy.select();
              document.execCommand("copy");
              document.body.removeChild(dummy);
            }}
          >
            <img src="/icons/share.svg" />
          </div>
          {/* <Link to={item.frontmatter.slug}>
            <img src="/icons/permalink.svg" />
          </Link> */}
        </div>
      </section>
      <Share isOpen={share} onClose={() => setShare(false)}>
        {item}
      </Share>
    </article>
  );
};

export default CinemaItem;
